<div *ngIf="(detailSubject$ | async) !== null" class="profile-component">
  <ng-container *ngIf="detailId">
    <app-profile-details *ngIf="isOwner()" [user$]="detailSubject$" [userId]="detailId"></app-profile-details>
    <app-profile-public *ngIf="!isOwner()" [user$]="detailSubject$" [userId]="detailId"></app-profile-public>
    <app-observation-list [userId]="detailId"></app-observation-list>
    <app-follow-list *ngIf="isOwner()"></app-follow-list>
    <app-activity *ngIf="isOwner()" [userId]="detailId"></app-activity>
  </ng-container>
</div>
